<script>
  export let title = 'Square';
  export let subtitle = 'Developer';
</script>

<svg class="DeveloperLockup" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 322.6 39" height="22">
  <path
    fill="black"
    d="m32.5,0H6.5C2.9,0,0,2.9,0,6.5v26c0,3.6,2.9,6.5,6.5,6.5h26c3.6,0,6.5-2.9,6.5-6.5V6.5c0-3.6-2.8-6.5-6.5-6.5Zm-.5,29.9c0,1.1-.9,2.1-2.1,2.1H9.2c-1.1,0-2.1-.9-2.1-2.1V9.1c0-1.1.9-2.1,2.1-2.1h20.8c1.1,0,2.1.9,2.1,2.1v20.8h0Zm-8.3-5.1c.7,0,1.2-.5,1.2-1.2v-8.3c0-.7-.5-1.2-1.2-1.2h-8.3c-.7,0-1.2.5-1.2,1.2v8.3c0,.7.5,1.2,1.2,1.2h8.3Zm25.7-.6h4.3c.2,2.4,1.9,4.3,5.2,4.3s4.8-1.5,4.8-3.7-1.4-3-4-3.6l-3.3-.7c-3.6-.8-6.3-3.1-6.3-6.9s3.7-7,8.5-7,8.4,2.7,8.6,6.6h-4.1c-.5-1.8-2-2.9-4.5-2.9s-4.4,1.4-4.4,3.2,1.6,2.9,4.3,3.5l3.3.7c3.6.8,6.1,2.9,6.1,6.8s-3.6,7.7-8.8,7.7c-6.1,0-9.3-3.1-9.7-8Zm33.5,14.8v-7.1l.3-3.1h-.3c-1,2.2-3,3.4-5.8,3.4-4.5,0-7.9-3.7-7.9-9.3s3.4-9.3,7.9-9.3,4.7,1.3,5.8,3.3h.3v-3h3.7v24.9c0,.2-4,.2-4,.2Zm.2-16c0-3.6-2.2-5.7-4.9-5.7s-4.9,2.1-4.9,5.7,2.2,5.7,4.9,5.7,4.9-2.1,4.9-5.7Zm6.8,1.9v-10.8h4v10.4c0,2.8,1.4,4.2,3.6,4.2s4.6-2,4.6-5.1v-9.5h4v17.9h-3.7v-3.7h-.3c-.9,2.4-2.8,4.1-5.8,4.1-4.2-.1-6.4-2.8-6.4-7.5Zm18.6,2.1c0-3.3,2.3-5.3,6.5-5.6l4.9-.3v-1.4c0-1.7-1.2-2.7-3.4-2.7s-3.2,1-3.5,2.4h-4c.4-3.6,3.4-5.7,7.5-5.7s7.4,1.9,7.4,5.7v12.5h-3.7v-3.3h-.3c-.8,2.2-2.6,3.7-5.9,3.7-3.2,0-5.5-2.2-5.5-5.3Zm11.4-2.2v-1l-4,.3c-2.2,0-3.1.9-3.1,2.6s1.1,2.3,2.7,2.3c2.8,0,4.4-1.8,4.4-4.2Zm6.9,7.2V14.1h3.7v3.4h.3c.5-2.3,2.3-3.4,4.9-3.4h1.8v3.6h-2.3c-2.6,0-4.5,1.7-4.5,4.8v9.4c.1,0-3.9,0-3.9,0Zm29-8.2h-13.6c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.6,3.6,8.6,8.1c0,.8,0,1.2,0,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.9,4.2h9.6Z"
  />
  <g>
    <path
      fill="black"
      d="m166.1,32V7.5h7.8c7.1,0,11.9,4.5,11.9,12.2s-4.8,12.2-11.9,12.2h-7.8Zm4.1-3.7h3.6c4.5,0,7.8-2.9,7.8-8.5s-3.3-8.5-7.8-8.5h-3.6v17Z"
    />
    <path
      fill="black"
      d="m205.5,23.8h-13.5c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.7,3.6,8.7,8.1-.1,1.2-.2,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.8,4.2h9.5Z"
    />
    <path fill="black" d="m212.6,32l-6.3-17.9h4.4l3.6,10.7.6,2.5h.3l.7-2.5,3.6-10.7h4.4l-6.3,17.9h-5Z" />
    <path
      fill="black"
      d="m241.7,23.8h-13.6c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.7,3.6,8.7,8.1c0,.8-.1,1.2-.1,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.8,4.2h9.5Z"
    />
    <path fill="black" d="m244.5,32V7.2h4v24.8h-4Z" />
    <path
      fill="black"
      d="m251.1,23c0-5.4,3.6-9.3,9-9.3s8.9,3.8,8.9,9.3-3.6,9.3-8.9,9.3-9-3.8-9-9.3Zm13.8,0c0-3.7-2.2-5.7-4.9-5.7s-4.9,2-4.9,5.7,2.2,5.7,4.9,5.7c2.7,0,4.9-2,4.9-5.7Z"
    />
    <path
      fill="black"
      d="m271.6,38.5V14.1h3.7v3h.3c1.1-2.1,3-3.4,5.8-3.4,4.5,0,7.8,3.7,7.8,9.3s-3.3,9.3-7.8,9.3-4.8-1.3-5.8-3.3h-.3l.3,3v6.6h-4Zm13.6-15.6c0-3.6-2.2-5.7-4.9-5.7s-4.9,2.1-4.9,5.7,2.2,5.7,4.9,5.7c2.7,0,4.9-2.1,4.9-5.7Z"
    />
    <path
      fill="black"
      d="m309,23.8h-13.6c.2,3.3,2.5,5.1,5.1,5.1s3.5-.9,4.3-2.3h3.9c-1.1,3.6-4.3,5.8-8.3,5.8s-9-3.9-9-9.3,3.8-9.3,9-9.3,8.7,3.6,8.7,8.1,0,1.2-.1,1.9Zm-3.8-2.8c-.1-2.5-2.2-4.2-4.7-4.2s-4.4,1.5-4.8,4.2h9.5Z"
    />
    <path fill="black" d="m311.8,32V14.1h3.7v3.4h.3c.5-2.3,2.3-3.4,5-3.4h1.8v3.6h-2.3c-2.6,0-4.5,1.7-4.5,4.8v9.4h-4Z" />
  </g>
</svg>
<span class="text">{title} {subtitle}</span>

<style>.DeveloperLockup {
  display: block;
  height: 22px;
  min-height: 22px;
  max-height: 22px;
}

[fill] {
  fill: var(--color-text, #1a1a1a);
}

.text {
  position: absolute;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  white-space: nowrap;
}</style>
